import React from 'react';
import { PapiCorePackage } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';
import SaleLabel from '../../../../../Sales/SaleLabel';

import s from './PackageSavingsLabel.scss';

interface Props {
  corePackage: PapiCorePackage;
  anyPackageHasDiscount: boolean;
  shouldPackageShowDiscount: boolean;
}

const PackageSavingsLabel: React.FC<Props> = ({
  corePackage,
  anyPackageHasDiscount,
  shouldPackageShowDiscount,
}) => {
  const { t } = useTranslation();
  const { interval } = corePackage;

  if (!anyPackageHasDiscount && interval === 'year') {
    return (
      <SaleLabel className={s['sale-label']}>
        {t('packagePicker.billingCycle.new.bulkSavings', {
          amount: formatDollars(corePackage?.bulkPriceSaving),
        })}
      </SaleLabel>
    );
  }
  if (shouldPackageShowDiscount) {
    return (
      <SaleLabel className={s['sale-label']}>
        {t('packagePicker.coreOffer.new.saleBadge', {
          discountPercent: corePackage.discountPercent,
        })}
      </SaleLabel>
    );
  }
  return null;
};
PackageSavingsLabel.displayName = 'PackageSavingsLabel';

export default PackageSavingsLabel;
